import React, {Component} from 'react';
import {connect} from "react-redux";
import {addSubField} from "../../../../../store/actions/subFields";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import ParametersNotice from "../../Parameters/ParametersNotice";
import { FieldGroup } from '../FieldGroup';
import getFieldFactory from '../../Endpoint/FieldFactory';
import FieldGroups from '../FieldGroups';

class RequestParameters extends Component {

	render() {

		const newCustomField = {
			name:   'request-parameter',
			label:  'Request Parameter',
			fields: [
				getFieldFactory().getSourceField(), getFieldFactory().getValueInputType(), {
					id:        'parameterName',
					inputType: 'input',
					value:     '',
					label:     'Parameter Name',
					dynamic:   false,
				}, getFieldFactory().getParametersField(),
				getFieldFactory().getDynamicField()
			],
		};

		const {addSubField, group} = this.props;

		return (
			<FieldGroupContext.Consumer>

				{({ endpointId, endpoint, currentItem, action }) => (

					<React.Fragment>
						<h3>Request Parameters</h3>
						<p>Here you should define custom query parameters you want to send along with the request. For this, you should add as many Request Parameters as you wish in order to compose request URL.</p>

						<ParametersNotice parameters={endpoint.parameters}/>

						<button onClick={() => addSubField(endpointId, [ newCustomField ], currentItem, group, action)} className="button-secondary">
							Add a request parameter
						</button>

						<FieldGroups group={group}/>

					</React.Fragment>
				)}

			</FieldGroupContext.Consumer>
		);
	}
}

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
	addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )(RequestParameters);
